import { isValid } from 'date-fns';
import { format as tzFormat } from 'date-fns-tz';

import { DATE_FORMATS } from '../constants';
import normalizeDate from './normalizeDate';
import toTimeZone from './toTimeZone';

/**
 * Formats a given date object or timestamp using yyyy-MM-dd and the UTC timezone by default.
 *
 * @see https://date-fns.org/v2.12.0/docs/Unicode-Tokens for the additional tokens
 * @see https://www.npmjs.com/package/date-fns-tz  Date and time zone formatting
 *
 * @param value - The dateTime to format.
 * @param options.format - The format to use for the resulting date string
 * @param options.timeZone - The time zone to use for the resulting date string
 * @returns A formatted date string or the given date if it cannot be formatted
 */
export default function formatDateTime(
  value?: string | Date | number,
  options?: {
    format?: string;
    timeZone?: string;
  },
) {
  const { format = DATE_FORMATS.YYYY_MM_DD_DATE_FNS, timeZone = 'UTC' } = options || {};

  if (!value) {
    return '';
  }

  const date = normalizeDate(value);

  if (!isValid(date)) {
    return value;
  }

  return tzFormat(toTimeZone(date, timeZone), format, { timeZone });
}
